import React from "react";
import { RotateCcw, Search, X } from "lucide-react";
import { Button } from "../ui/button";
import { Input } from "../ui/input";

const AdminListToolbar = ({
  searchValue,
  onSearchChange,
  searchPlaceholder = "Search...",
  searchLabel = "Search records",
  filteredCount,
  totalCount,
  itemLabel = "records",
  hasActiveFilters = false,
  onReset,
  children,
}) => (
  <div className="rounded-lg border border-white/60 bg-white/80 p-4 shadow-sm backdrop-blur-xl">
    <div className="flex flex-col gap-3 lg:flex-row lg:items-center">
      <div className="relative min-w-0 flex-1 lg:max-w-xl">
        <Search className="pointer-events-none absolute left-3.5 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400" />
        <Input
          type="search"
          value={searchValue}
          onChange={(event) => onSearchChange(event.target.value)}
          placeholder={searchPlaceholder}
          aria-label={searchLabel}
          className="h-11 rounded-lg border-slate-200 pl-10 pr-10"
        />
        {searchValue ? (
          <button
            type="button"
            onClick={() => onSearchChange("")}
            className="absolute right-2.5 top-1/2 flex h-7 w-7 -translate-y-1/2 items-center justify-center rounded-lg text-slate-400 transition hover:bg-slate-100 hover:text-slate-700"
            aria-label={`Clear ${searchLabel.toLowerCase()}`}
          >
            <X className="h-4 w-4" />
          </button>
        ) : null}
      </div>

      {children ? <div className="grid min-w-0 gap-3 sm:grid-cols-2 lg:flex lg:items-center">{children}</div> : null}

      {hasActiveFilters && onReset ? (
        <Button type="button" variant="outline" className="h-11 rounded-lg" onClick={onReset}>
          <RotateCcw className="mr-2 h-4 w-4" />
          Reset
        </Button>
      ) : null}
    </div>

    <p className="mt-3 text-sm font-medium text-slate-500">
      Showing <span className="font-bold text-slate-700">{filteredCount}</span> of {totalCount} {itemLabel}
    </p>
  </div>
);

export default AdminListToolbar;
